import React from 'react';
import PropTypes from 'prop-types';

import StarRating from 'Components/ProductReviews/UserReviews/StarRating';

import 'Components/PickAndMix/Cards/PickAndMixStars.scss';

const PickAndMixStars = ({ ratingScore }) => {
  if (!ratingScore) return false;
  return (
    <div className="PickAndMixStars">
      <StarRating rating={ratingScore} />
    </div>
  );
};

PickAndMixStars.propTypes = {
  ratingScore: PropTypes.number,
};

PickAndMixStars.defaultProps = {
  ratingScore: 0,
};

export default PickAndMixStars;
